import { PaymentPlanModel } from "@/backend/domains/subscription/infrastructure/local/paymentPlan.model";

import { Interval } from "../../payment-system/infrastructure/tiptop/types/types";

//

export enum EPaymentPlan {
  SUPER = "SUPER",
  FREE = "FREE",
  START = "START",
  PRO = "PRO",
  PRO_PLUS = "PRO+",
  UNLIMITED = "UNLIMITED",
  BETA = "BETA",
}

//

export const paymentPlansMap: Record<EPaymentPlan, PaymentPlanModel> = {
  FREE: {
    description: "Бесплатный ограниченный тариф.",
    monthlyPrice: 0,
    available: false,
    features: {
      free: true,
      base: false,
      baseAnalytics: false,
      fullAnalytics: false,
      ai: false,
    },
    usageLimits: {
      PRODUCTS: false,
      ORDERS_PER_MONTH: false,
      OFFER_CONNECTS_PER_DAY: false,
      OFFER_CONNECTS_PER_MONTH: false,
      CABINETS: 1,
    },
  },

  START: {
    description: "Для небольших магазинов, с ограниченной аналитикой.",
    monthlyPrice: 21000,
    available: true,
    features: {
      free: true,
      base: true,
      baseAnalytics: true,
      fullAnalytics: false,
      ai: false,
    },
    usageLimits: {
      PRODUCTS: 50,
      ORDERS_PER_MONTH: null,
      OFFER_CONNECTS_PER_DAY: null,
      OFFER_CONNECTS_PER_MONTH: null,
      CABINETS: 1,
    },
  },

  PRO: {
    monthlyPrice: 42000,
    oldPrice: 42000,
    description: "Идеально для большинства, с полным доступом к аналитике.",
    available: true,
    features: {
      free: true,
      base: true,
      baseAnalytics: true,
      fullAnalytics: true,
      ai: false,
    },
    usageLimits: {
      PRODUCTS: 100,
      ORDERS_PER_MONTH: null,
      OFFER_CONNECTS_PER_DAY: null,
      OFFER_CONNECTS_PER_MONTH: null,
      CABINETS: 1,
    },
  },

  "PRO+": {
    description: "Увеличенный PRO. Для тех, у кого много товаров.",
    monthlyPrice: 60000,
    available: true,
    features: {
      free: true,
      base: true,
      baseAnalytics: true,
      fullAnalytics: true,
      ai: false,
    },
    usageLimits: {
      PRODUCTS: 1000,
      ORDERS_PER_MONTH: null,
      OFFER_CONNECTS_PER_DAY: null,
      OFFER_CONNECTS_PER_MONTH: null,
      CABINETS: 1,
    },
  },

  UNLIMITED: {
    monthlyPrice: 96000,
    oldPrice: 120000,
    description: "Большой лимит на товары и поддержка нескольких магазинов.",
    available: true,
    features: {
      free: true,
      base: true,
      baseAnalytics: true,
      fullAnalytics: true,
      ai: true,
    },
    usageLimits: {
      PRODUCTS: 3000,
      ORDERS_PER_MONTH: null,
      OFFER_CONNECTS_PER_DAY: null,
      OFFER_CONNECTS_PER_MONTH: null,
      CABINETS: 5,
    },
  },

  BETA: {
    monthlyPrice: 23700,
    oldPrice: 120000,
    description: "Для 10 участников закрытой Бета версии. До 1 июля 2025.",
    available: false,
    features: {
      free: true,
      base: true,
      baseAnalytics: true,
      fullAnalytics: true,
      ai: true,
    },
    usageLimits: {
      PRODUCTS: 3000,
      ORDERS_PER_MONTH: null,
      OFFER_CONNECTS_PER_DAY: null,
      OFFER_CONNECTS_PER_MONTH: null,
      CABINETS: 5,
    },
  },

  SUPER: {
    monthlyPrice: 0,
    available: false,
    features: {
      free: true,
      base: true,
      baseAnalytics: true,
      fullAnalytics: true,
      ai: true,
    },
    usageLimits: {
      PRODUCTS: null,
      ORDERS_PER_MONTH: null,
      OFFER_CONNECTS_PER_DAY: null,
      OFFER_CONNECTS_PER_MONTH: null,
      CABINETS: null,
    },
  },
};

//

export interface PeriodItem {
  id: string;
  period: number;
  interval: Interval;
  discount: number;
}

export const paymentPlanPeriods: PeriodItem[] = [
  // "1D": {
  //   period: 1,
  //   interval: "Day" as Interval,
  //   discount: -5,
  // },
  // "1W": {
  //   period: 1,
  //   interval: "Week" as Interval,
  //   discount: -1,
  // },
  {
    id: "1M",
    period: 1,
    interval: "Month",
    discount: 0,
  },
  {
    id: "3M",
    period: 3,
    interval: "Month",
    discount: 0.1,
  },
  {
    id: "6M",
    period: 6,
    interval: "Month",
    discount: 0.15,
  },
  {
    id: "12M",
    period: 12,
    interval: "Month",
    discount: 0.3,
  },
];
